/**
 * The MIT License (MIT)
 *
 * Copyright (c) 2020 Julien CARON
 */

import { useCallback, useEffect, useRef } from 'react'

export default function useEventCallback<Args extends unknown[], R>(
  fn: (...args: Args) => R
) {
  const ref = useRef<typeof fn>(() => {
    throw new Error('Cannot call an event handler while rendering.')
  })

  useEffect(() => {
    ref.current = fn
  }, [fn])

  return useCallback((...args: Args) => ref.current(...args), [ref])
}
